import React from 'react';
import { ResourceContextProvider, List, Pagination } from 'react-admin';
import { PER_PAGE, MAX_ROWS_PER_PAGE_OPTIONS } from '../../constants';

const TList = ({ children, ...props }) => (
	<ResourceContextProvider value={props.resource}>
		<List {...props} pagination={<Pagination rowsPerPageOptions={MAX_ROWS_PER_PAGE_OPTIONS} />} perPage={PER_PAGE} bulkActionButtons={false}>
			{children}
		</List>
	</ResourceContextProvider>
);

export default TList;
